module.exports = __webpack_public_path__ + "media/images/mailer/icon_grade-0a28684ef0ddb798b1d5802fe4a5cd3b.png";